export function rng(): Uint8Array {
	const rnds8 = new Uint8Array(16);
	crypto.getRandomValues(rnds8);
	return rnds8;
}

export default rng;
